import { collection, onSnapshot, query, orderBy, limit, doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { firestore } from './firebase/firebase';

/**
 * Notifications « centre admin » : messages clients dans le chat de création
 * (request_message) et réponses clients sur les tickets de support (ticket_reply).
 * Documents écrits par les Cloud Functions (collection racine adminNotifications).
 */

const normalize = (doc) => {
  const data = doc.data();
  return {
    id: doc.id,
    ...data,
    createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : data.createdAt
  };
};

/**
 * Observe les dernières notifications (toutes, on filtre « non lues » côté client).
 * @param {Function} callback - reçoit la liste des notifications (triées desc)
 * @return {Function} fonction de désabonnement
 */
export const observeAdminNotifications = (callback) =>
  onSnapshot(
    query(collection(firestore, 'adminNotifications'), orderBy('createdAt', 'desc'), limit(40)),
    (snapshot) => callback(snapshot.docs.map(normalize)),
    (error) => console.error('adminNotificationsService: erreur observation:', error)
  );

/**
 * Marque des notifications comme lues.
 * @param {string[]} ids - Identifiants des notifications
 * @return {Promise<void>}
 */
export const markAdminNotificationsRead = async (ids) => {
  await Promise.all(
    ids.map((id) => updateDoc(doc(firestore, 'adminNotifications', id), {
      read: true,
      readAt: serverTimestamp()
    }))
  );
};
